import React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgStar = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M26.16 10.638a1.792 1.792 0 0 0-1.56-1.232l-6.453-.52-2.491-6.026a1.789 1.789 0 0 0-3.31 0l-2.49 6.025-6.457.521a1.8 1.8 0 0 0-1.024 3.157l4.921 4.247-1.5 6.35a1.791 1.791 0 0 0 2.68 1.95L14 21.71l5.527 3.4a1.794 1.794 0 0 0 2.676-1.95l-1.505-6.351 4.922-4.247a1.797 1.797 0 0 0 .54-1.924Zm-1.677.598-5.327 4.594a.875.875 0 0 0-.28.865l1.627 6.869a.04.04 0 0 1-.019.052c-.019.016-.024.012-.04 0l-5.986-3.68a.874.874 0 0 0-.916 0l-5.985 3.682c-.017.01-.021.014-.042 0a.04.04 0 0 1-.018-.052l1.627-6.869a.875.875 0 0 0-.28-.865l-5.326-4.594c-.014-.01-.026-.02-.015-.054s.02-.03.036-.032l6.992-.564a.876.876 0 0 0 .735-.54l2.693-6.52c.008-.02.011-.028.038-.028.026 0 .03.009.038.027l2.7 6.52a.875.875 0 0 0 .738.538l6.99.565c.017 0 .027 0 .037.031.01.032 0 .044-.017.055Z" />
  </svg>
);
export default SvgStar;
